/**
 * Pronto Posto – Maildaten · Deutsch (de-DE) · KS04
 *
 * KS04 Flug – Lady Luna / Max Lange. Postfach: m.lange@pronto-posto.com
 *
 * Aufteilung nach language/episode: geteilte Inhalte einer Sprache leben in ./_shared.js.
 * Sprachen sind strikt getrennt – Mails dieser Datei adressieren ausschliesslich Postfaecher
 * dieser Sprache. IDs sind global eindeutig (siehe ID-Reservierungen in den Blockkommentaren).
 */
/* eslint-disable */

export function getEmails() {
    return [
        // luna–lange mails (ks04 flug)


        {
            id: 21,
            from: {
                email: 'lady.luna@seelenraum-tv.de',
                name: 'Lady Luna',
                avatar: require('@src/assets/images/portrait/luna.jpg').default
            },
            to: [{
                name: 'Max Lange',
                email: 'm.lange@pronto-posto.com'
            }],
            subject: 'Re: Anfrage: Sonder-Seance in Ihrer Sendung',
            cc: [],
            bcc: [],
            message: 'Max,<p>das Thema scheint ja sehr wichtig für Sie zu sein. Damit wir ganz sicher gehen, dass die Karten sich nicht doch unerwartet anders entscheiden oder ich mich in der Show verplappere, müssten es schon 6000€ Honorar sein.<p>Gruß<p> Lady Luna',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Thu. Mar. 28 2024 15:08:00 GMT+0000 (GMT)',
            replies: [
                {
                    id: 20,
                    from: {
                        email: 'm.lange@pronto-posto.com',
                        name: 'Max Lange',
                        avatar: require('@src/assets/images/portrait/lange.jpg').default
                    },
                    to: [{
                        name: 'Lady Luna',
                        email: 'lady.luna@seelenraum-tv.de'
                    }],
                    subject: 'Anfrage: Sonder-Seance in Ihrer Sendung',
                    cc: [],
                    bcc: [],
                    message: 'Hallo Lady Luna,<p>wenn ich Sie richtig einschätze, sind wir quasi Berufskollegen, und Sie sind einem kleinen Zusatzverdienst nie abgeneigt.<p>Ich hätte da einen Spezialauftrag: Meine abergläubische Schwiegermutter Krystyna Zielinski wird vermutlich am 31.03. bei Ihnen zum 10 Jahres Jubiläum von Ihrem Sender durchklingeln. Sie ist einer Ihrer Stamm-Zuseher. Sie muss unter allen Umständen davon überzeugt werden, ihre Landvilla an ihre Tochter (und mich) zu überschreiben. Bitte sorgen Sie in der Sendung dafür, dass die Karten klar zur Schenkung raten – egal, was sie wirklich sagen.<p>Ich biete 3000€ Honorar. Diskretion setze ich voraus.<p><p>Gruß<p>Max Lange',
                    attachments: [],
                    isStarred: false,
                    labels: ['personal'],
                    time: 'Thu. Mar. 28 2024 14:02:00 GMT+0000 (GMT)',
                    replies: [],
                    folder: 'sent',
                    isRead: true
                }
            ],
            folder: 'inbox',
            isRead: true
        },

        {
            id: 23,
            from: {
                email: 'lady.luna@seelenraum-tv.de',
                name: 'Lady Luna',
                avatar: require('@src/assets/images/portrait/luna.jpg').default
            },
            to: [{
                name: 'Max Lange',
                email: 'm.lange@pronto-posto.com'
            }],
            subject: 'Re: Re: Re: Anfrage: Sonder-Seance in Ihrer Sendung',
            cc: [],
            bcc: [],
            message: 'Geld ist eingegangen. Ich richte die Karten wie gewünscht aus – Ihre Schwiegermutter bekommt das perfekte Zeichen zur Schenkung.<p>Ich lasse Ihnen einen Best-Of Clip zukommen, sobald die Show im Kasten ist.<p>Auf weitere gute Geschäfte<p>Lady Luna',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Thu. Mar. 28 2024 21:58:00 GMT+0000 (GMT)',
            replies: [
                {
                    id: 22,
                    from: {
                        email: 'm.lange@pronto-posto.com',
                        name: 'Max Lange',
                        avatar: require('@src/assets/images/portrait/lange.jpg').default
                    },
                    to: [{
                        name: 'Lady Luna',
                        email: 'lady.luna@seelenraum-tv.de'
                    }],
                    subject: 'Re: Re: Anfrage: Sonder-Seance in Ihrer Sendung',
                    cc: [],
                    bcc: [],
                    message: 'Soll das eine Erpressung werden???? Frechheit. Aber okay, ich bin heute in guter Laune. 5000€ aber keinen Cent mehr. Am besten in Krypto. Lassen Sie uns nachher mal telefonieren. +49 XXXXX152.',
                    attachments: [],
                    isStarred: false,
                    labels: ['personal'],
                    time: 'Thu. Mar. 28 2024 18:22:00 GMT+0000 (GMT)',
                    replies: [],
                    folder: 'sent',
                    isRead: true
                }
            ],
            folder: 'inbox',
            isRead: true
        },

        {
            id: 24,
            from: {
                email: 'lady.luna@seelenraum-tv.de',
                name: 'Lady Luna',
                avatar: require('@src/assets/images/portrait/luna.jpg').default
            },
            to: [{
                name: 'Max Lange',
                email: 'm.lange@pronto-posto.com'
            }],
            subject: 'Die Karten haben gesprochen',
            cc: [],
            bcc: [],
            message: 'Max,<p>Die Karten haben gesprochen. Im Anhang ist der Clip bezüglich unseres kleinen Arrangements.<p>Auf weitere gute Geschäfte<p>Lady Luna<p>PS: Falls Sie öfter Hilfe brauchen: Bei SeelenraumTV gibt’s für jedes Anliegen eine Lösung, solange das Universum (und Ihr Konto) mitspielt.',
            attachments: [
                {
                    fileName: 'clip_seelenraum_tv.mp4',
                    thumbnail: require('@src/assets/images/icons/jpg.png').default,
                    url: 'https://storage.googleapis.com/cc-pronto-posto/ks04_seelenraum_clip.mp4',
                    size: '10mb',
                },
            ],
            isStarred: true,
            labels: ['personal'],
            time: 'So. Mar. 31 2024 15:45:00 GMT+0000 (GMT)',

            replies: [
                {
                    id: 25,
                    from: {
                        email: 'm.lange@pronto-posto.com',
                        name: 'Max Lange',
                        avatar: require('@src/assets/images/portrait/lange.jpg').default
                    },
                    to: [{
                        name: 'Lady Luna',
                        email: 'lady.luna@seelenraum-tv.de'
                    }],
                    subject: 'Re: Die Karten haben gesprochen',
                    cc: [],
                    bcc: [],
                    message: 'Hab eben den Best-Of Clip angeschaut, man was für Spinner hahaha, dachte sowas gibt’s nur in der Krypto Bubble. Aber egal, Krystyna hat den Köder geschluckt. <p>Danke für die „göttliche“ Unterstützung.<p>Melde mich wieder, falls Bedarf!',
                    attachments: [],
                    isStarred: false,
                    labels: ['personal'],
                    time: 'So. Mar. 31 2024 18:40:00 GMT+0000 (GMT)',
                    replies: [],
                    folder: 'sent',
                    isRead: true
                },
            ],
            folder: 'inbox',
            isRead: true
        },
        {
            id: 26,
            from: {
                email: 'renderrambo@pronto-posto.com',
                name: 'Render Rambo',
                avatar: require('@src/assets/images/portrait/rambo.jpg').default
            },
            to: [{
                name: 'Max Lange',
                email: 'm.lange@pronto-posto.com'
            }],
            subject: 'Neues Reel',
            cc: [],
            bcc: [],
            message: 'Hey Maxx,<p>Hab dein Reel fertig gecuttet, richtig fresh geworden! Die Finanzbros werden es lieben, schick mir doch die Bezahlung gleich als BillionCoins, mich hast du total überzeugt :P<p>Lass mich auf jeden Fall wissen, ob dir das Video taugt, so wie es ist, oder ob ich noch was dran ändern soll.<p>Video ist im Anhang<p>P.S: Lad mich dann mal auf deinen neuen Schlitten ein ;)',
            attachments: [
                {
                    fileName: 'CryptoReel_Maxx.mp4',
                    thumbnail: require('@src/assets/images/icons/mp4.png').default,
                    url: 'https://storage.googleapis.com/cc-pronto-posto/ks04_cryptoreel_maxx.mp4',
                    size: '10mb',
                },
            ],
            isStarred: false,
            labels: ['work'],
            time: 'So. Feb. 25 2024 16:45:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: true
        },
    ]
}

export function getSpam() {
    return [
        //ks04 flug
        {
            id: 110,
            from: {
                email: 'omar@takatukaland-royal.org',
                name: 'Prinz Omar',
                avatar: require('@src/assets/images/portrait/prince.jpg').default
            },
            to: [{
                name: 'Maximilian Lange',
                email: 'm.lange@pronto-posto.com'
            }],
            subject: 'Prinz Omar braucht Ihre Hilfe!',
            cc: [],
            bcc: [],
            message: '<p>Lieber Freund,</p><p>Ich bin Prinz Omar vom fernen Königreich Takatukaland. Leider sitze ich auf Millionen Goldmünzen fest, die nur Sie retten können!</p><p>Helfen Sie mir, mein Vermögen auf Ihr Konto zu übertragen, und Sie erhalten lebenslang Einladungen zu königlichen Teepartys.</p><p><b>Bitte beeilen Sie sich, meine Tee-Vorräte sind begrenzt!</b></p><br><p>Euer verzweifelter Prinz Omar</p>',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Mi. Jul. 10 2024 18:24:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },
        {
            id: 111,
            from: {
                email: 'info@wohlfuehlwunder.com',
                name: 'Wohlfühlwunder-Team',
                avatar: require('@src/assets/images/portrait/vitamins.jpg').default
            },
            to: [{
                name: 'Maximilian Lange',
                email: 'm.lange@pronto-posto.com'
            }],
            subject: 'Ärzte sind schockiert! Gemüse ist überflüssig!',
            cc: [],
            bcc: [],
            message: '<p>Lieber gesundheitsbewusster Freund,</p><p>Vergessen Sie Brokkoli, Spinat und Karotten! Unsere revolutionären Gummibärchen enthalten alle Vitamine, die Sie jemals brauchen könnten.</p><p>Bestellen Sie heute und wir senden Ihnen zusätzlich eine Packung Schokoladensalat gratis dazu!</p><br><p>Bleiben Sie gesund,<br>Ihr Wohlfühlwunder-Team</p>',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Do. Jul. 18 2024 20:11:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },
        {
            id: 112,
            from: {
                email: 'service@cosmic-realestate.com',
                name: 'Kosmisches Immobilien-Team',
                avatar: require('@src/assets/images/portrait/moon.jpg').default
            },
            to: [{
                name: 'Maximilian Lange',
                email: 'm.lange@pronto-posto.com'
            }],
            subject: 'Ihr eigenes Grundstück auf dem Mond wartet!',
            cc: [],
            bcc: [],
            message: '<p>Sehr geehrte/r zukünftige Mondbesitzer/in,</p><p>Nutzen Sie jetzt Ihre einmalige Chance, offizieller Besitzer eines Grundstücks auf dem Mond zu werden.</p><p>Sichern Sie sich noch heute einen exklusiven Bauplatz mit unverbaubarem Blick auf die Erde. Limitierte Verfügbarkeit!</p><br><p>Ihr kosmisches Immobilien-Team</p>',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Di. Jul. 23 2024 10:50:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },
        {
            id: 113,
            from: {
                email: 'jobs@aqua-careers.org',
                name: 'Aquatisches Karriere-Team',
                avatar: require('@src/assets/images/portrait/dolphin.jpg').default
            },
            to: [{
                name: 'Maximilian Lange',
                email: 'm.lange@pronto-posto.com'
            }],
            subject: 'Wir suchen Delfin-Übersetzer – lukrative Gelegenheit!',
            cc: [],
            bcc: [],
            message: '<p>Sehr geehrte/r Meerliebhaber/in,</p><p>Sind Sie bereit für eine außergewöhnliche Karriere?</p><p>Wir suchen dringend Menschen, die Delfin-Sprache verstehen oder lernen möchten. Keine Vorerfahrung nötig, großzügige Vergütung garantiert.</p><p>Bewerben Sie sich heute noch!</p><br><p>Ihr aquatisches Karriere-Team</p>',
            attachments: [],
            isStarred: false,
            labels: ['company'],
            time: 'Mo. Jul. 29 2024 04:01:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },
    ]
}
